import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  ITStaffRapidTeam,
  ITStaffSkills,
  ITStaffCostFlexibility,
} from "../../../../app-constants";

function Addressingitstaff() {
  return (
    <section className="addressing_it_staff p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={8}
            xxl={7}
            className="m-auto text-center"
          >
            <h2>Addressing Your IT Staffing Challenges</h2>
          </Col>
        </Row>
        <Row className="mt-5">
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="addressing_it_box">
              <div className="addressing_it_img">{ITStaffRapidTeam}</div>
              <div className="addressing_it_content">
                <h5>Rapid Team Expansion</h5>
                <p>
                  As your business grows, so do your IT needs. Finding the right
                  talent quickly can be a daunting task, leading to project
                  delays and missed opportunities. With TekRevol’s staff
                  augmentation, you can scale your team as needed. Access the
                  right skills at the right time.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="addressing_it_box">
              <div className="addressing_it_img">{ITStaffSkills}</div>
              <div className="addressing_it_content">
                <h5>Access to Specialized Skills</h5>
                <p>
                  Certain projects require niche expertise that may not be
                  available within your current team. Our extensive network of
                  IT professionals spans various domains, from cloud computing
                  and software to AI and data analytics. Tackle complex
                  challenges with a great team, that is as dedicated as your
                  in-house experts.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="addressing_it_box">
              <div className="addressing_it_img">{ITStaffCostFlexibility}</div>
              <div className="addressing_it_content">
                <h5>Cost-Effective Flexibility</h5>
                <p>
                  Hiring full-time employees involves significant costs and
                  long-term commitments. Our IT staff augmentation services
                  offer a flexible, cost-effective alternative, allowing you to
                  manage your resources efficiently without compromising on
                  quality.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Addressingitstaff;
